import { BranchExpenditureAction } from '@pages/Authorized/Branch/ExpenditurePage'

import PageTitle, { PageTitleAction } from '@components/molecules/PageTitle'

type Props = {
  onAction: (type: BranchExpenditureAction) => void
}

export default function BranchExpenditureTitle({ onAction }: Props): JSX.Element {
  const actions: PageTitleAction[] = [
    { label: '내보내기', buttonType: 'dashed', onClick: () => onAction('export') },
    { label: '지출 추가', buttonType: 'primary', onClick: () => onAction('add') },
  ]

  return <PageTitle title="지출" actions={actions} />
}
